import React, { FC, useContext } from "react";
import FormRow from "../../../Components/FormRow";
import LocalizationContext from "../../../Localization/LanguageContext";
import { ILocalizationContext } from "../../../Localization/Models/ILocalizationContext";
import "./Confidentiality.css";

interface Props {
  confViewed: boolean;
  setConfViewed: React.Dispatch<React.SetStateAction<boolean>>;
}

const Confidentiality: FC<Props> = ({ confViewed, setConfViewed }) => {
  const { getValue } = useContext(LocalizationContext) as ILocalizationContext;
  const handleScroll = (event: { target: any }) => {
    const target = event.target;

    if (target.scrollHeight - target.scrollTop - target.clientHeight < 2) {
      setConfViewed(true);
    }
  };

  return (
    <>
      <FormRow>
        <h3 className="font-header-medium solo-header">
        {getValue('Confidentiality', 'ConfidentialityHeading')}
        </h3>
        <div className="agree-box" onScroll={handleScroll}>
          <p className="conf-p">
            {getValue('Confidentiality','Section1.1')}
            <i>{getValue('Confidentiality','Section1.1.2')}</i>
            {getValue('Confidentiality','Section1.1.3')}
            <i>{getValue('Confidentiality','Section1.2')}</i>
            {getValue('Confidentiality','Section1.3')}
          </p>
          <p className="conf-p">
            {getValue('Confidentiality','Section2.1')}
            <i>{getValue('Confidentiality','Section2.2')}</i>
            {getValue('Confidentiality','Section2.3')}
          </p>
          <div className="dot-text">
            <div className="dot-bullet">■</div>
            <span>
            {getValue('Confidentiality','Section2a')}
            </span>
          </div>
          <div className="dot-text">
            <div className="dot-bullet">■</div>
            {getValue('Confidentiality','Section2b')}
          </div>
          <div className="dot-text">
            <div className="dot-bullet">■</div>
            <div>
              {getValue('Confidentiality','Section2c.1')}
              <i>{getValue('Confidentiality','Section2c.2')}</i>
              {getValue('Confidentiality','Section2c.3')}
            </div>
          </div>
          <p className="conf-p">
          {getValue('Confidentiality','Section3.1')}
          <i>{getValue('Confidentiality','Section3.2')}</i>
          {getValue('Confidentiality','Section3.3')}
          </p>
          <p className="conf-p">
          {getValue('Confidentiality','Section4')}
          </p>
          <p className="conf-p">
          {getValue('Confidentiality','Section5')}
          </p>
        </div>
        {confViewed ? (
          <div className="composite-msg">
            <p>
            <span className="bold-msg">{getValue('Confidentiality', 'ConfidentialityPostScroll1')}</span>
            <span className="std-msg"> {getValue('Confidentiality', 'ConfidentialityPostScroll2')}</span>
            <span className="bold-msg"> {getValue('Confidentiality', 'ConfidentialityPostScroll3')}</span>
            <span className="std-msg"> {getValue('Confidentiality', 'ConfidentialityPostScroll4')}</span>
            </p>
          </div>
        ) : (
          <div className="composite-msg">
            <p>
            <span className="bold-msg">{getValue('Confidentiality', 'ConfidentialityPreScroll1')}</span>
            <span className="std-msg"> {getValue('Confidentiality', 'ConfidentialityPreScroll2')}</span>
            <span className="bold-msg"> {getValue('Confidentiality', 'ConfidentialityPreScroll3')}</span>
            <span className="std-msg"> {getValue('Confidentiality', 'ConfidentialityPreScroll4')}</span>
            </p>
          </div>
        )}
      </FormRow>
      <div className="base-row">
        <hr className="line-style" />
      </div>
    </>
  );
};

export default Confidentiality;
